<template>
  <div>
    <SportsTherapyComp v-bind:mobile="mobile"/>
    <FollowUs v-bind:mobile="mobile"/>
  </div>
</template>

<script>
import SportsTherapyComp from "@/components/desktop/Activities/SportsTherapyComp";
import FollowUs from '@/components/desktop/FollowUs'

  export default {
    name: 'SportsTherapy',
    props: ['mobile'],
    components: {
      SportsTherapyComp,
      FollowUs
    },
  }
</script>
